const forms = [
  {
    name: "Journal Information",
    className: "bg-white p-4 rounded-md p-8 w-[70%] mx-auto",
    options: [
      {
        name: "Is Contra Entry",
        type: "checkbox",  
        form: {
          name: "isContraEntry",
          value: false,
          required: false,
        },
      },
      {
        name: "Date",
        type: "date",
        form: {
          type: "date",
          name: "date",
          placeholder: "",
          class: "",
          value: new Date().toISOString().split("T")[0],
          required: true,
        },
      },
      {
        name: "Reference Number",
        type: "input",
        form: {
          type: "text",
          name: "referenceNumber",
          placeholder: "JE-001/2025",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Description",
        type: "input",
        form: {
          type: "text",
          name: "description",
          placeholder: "Enter journal description",
          class: "",
          value: "",
          required: true,
        },
      },
    ],
  },
];

export default forms;
